import { __decorate, __metadata } from "tslib";
import { Event } from '@ftr/bus-messages';
import { Type } from '@ftr/serialization';
import { LiveSttResult } from './LiveSttResult';
/**
 * Updated implies created or modified within the context of this event.
 */
export class LiveSttResultUpdated extends Event {
    constructor(recordingId, result) {
        super();
        this.recordingId = recordingId;
        this.$name = LiveSttResultUpdated.NAME;
        this.$version = 0;
        this.result = result;
    }
}
LiveSttResultUpdated.NAME = 'ftr-regional-api/LiveSttResultUpdated';
__decorate([
    Type(() => LiveSttResult),
    __metadata("design:type", LiveSttResult)
], LiveSttResultUpdated.prototype, "result", void 0);
